<template>
  <div class="c--about-us_learn-more-about-airalo new-container mx-auto">
    <div class="learn-more-about-airalo mt-20 mt-md-30 mt-lg-40">
      <nuxt-img
        class="learn-more-about-airalo-img"
        src="/assets/images/about-us/about-us-learn-more-banner.jpg"
        width="1132"
        heigth="408"
        alt
        loading="lazy"
      />
      <div class="learn-more-about-airalo-texts">
        <h2 class="learn-more-about-airalo-title">
          {{ title }}
        </h2>
        <nuxt-link
          @click.native="
            sendEventHandler({
              text: $t('scenes.about.us.learn-more-button-title'),
              url: link ? localePath(link) : localePath(learnMoreLink),
            })
          "
          :to="link ? localePath(link) : localePath(learnMoreLink)"
          class="learn-more-btn call-to-action light no-outline"
        >
          {{ $t('scenes.about.us.learn-more-button-title') }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'learn-more-about-airalo',

    props: ['title', 'link'],

    data() {
      return {
        learnMoreLink: '/learn-more',
      }
    },

    methods: {
      sendEventHandler(payload) {
        this.$utils.sendEvent('ctaClick', payload)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .learn-more-about-airalo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 22px;
    box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
    height: 408px;
    padding: 20px;
    position: relative;
    overflow: hidden;

    &-img {
      z-index: 0;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 408px;
      object-fit: contain;
    }

    &-texts {
      z-index: 1;
      max-width: 446px;
    }

    &-title {
      color: #ffffff;
      font-size: 27px;
      font-weight: 600;
      letter-spacing: -0.5px;
      line-height: 32px;
      text-align: center;
      margin-bottom: 0;
    }

    .learn-more-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 44px;
      margin-top: 20px;

      &:hover {
        text-decoration: none;
      }
    }
  }
</style>
